import axios from "axios";

const api = axios.create({
	baseURL: process.env.REACT_APP_BACKEND_URL,
	withCredentials: true,
});

// Interceptor para tratar erros de sessão expirada (401)
api.interceptors.response.use(
	(response) => response,
	(error) => {
		// Se o servidor retornar 401 (Não autorizado/Sessão expirada)
		if (error.response && error.response.status === 401) {
			// Limpa os dados de login antigos do navegador
			localStorage.removeItem("token");
			localStorage.removeItem("userId");
			
			// Redireciona para a tela de login de forma limpa
			window.location.href = "/login";
		}
		return Promise.reject(error);
	}
);

export const openApi = axios.create({
	baseURL: process.env.REACT_APP_BACKEND_URL
});

export default api;